module.exports = __webpack_public_path__ + "media/src/images/icon__happy--1--dark-b4e95369ba23ba37a83c4ec0db04ae43.png";